import Center from "layouts/wrapper/Center";
import style from "./ProcessBar.module.css";
import Inline from "layouts/container/Inline";
import P from "components/P";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import cartIcon from "resources/img/puffu/cart.png";
import coinIcon from "resources/img/puffu/coin.png";
import boxIcon from "resources/img/puffu/box.png";
import Dummy from "components/Dummy";

function ProcessBar(props) {
    return (
        <div className={props.modal ? style.modalContainer : style.container}>
            <Center textAlign={props.modal ? "left" : "right"} width={"100%"}>
                <Inline>
                    <img src={cartIcon} width={"25px"} style={{
                        filter: props.modal && "invert(100%)",
                        opacity: props.cart
                            ?
                            1
                            :
                            props.payment ? 1 : 
                            props.complete ?
                            1
                            :
                            0.5
                    }} />
                    <P weight={"bold"} size={20}
                        opacity={
                            props.cart ?
                                1
                                :
                                props.payment 
                                ? 
                                1 
                                : 
                                props.complete 
                                ?
                                1
                                :
                                0.5
                        }
                    > 상품담기 </P>
                    <FontAwesomeIcon opacity={
                        props.cart ?
                            1
                            :
                            props.payment ? 1 : props.complete ?
                            1
                            :
                            0.5
                    } icon={fas["faAngleRight"]} size={"xl"} />

                    <Dummy width={"15px"} />

                    <img src={coinIcon} width={"30px"} style={{
                        filter: props.modal && "invert(100%)",
                        opacity: props.cart ? 0.5 : props.payment ? 1 : props.complete ?
                        1
                        :
                        0.5
                    }} />
                    <P weight={"bold"} size={20} opacity={
                        props.cart ?
                            0.5
                            :
                            props.payment ? 1 : props.complete ?
                            1
                            :
                            0.5
                    }> 결제하기 </P>
                    <FontAwesomeIcon icon={fas["faAngleRight"]} size={"xl"} style={{
                        opacity: 
                        props.cart ?
                            0.5 :
                            props.payment ? 1 : props.complete ?
                            1
                            :
                            0.5
                    }} />
                    <Dummy width={"15px"} />
                    <img src={boxIcon} width={"25px"} style={{
                        opacity: props.cart ? 0.5 : props.payment ? 0.5 : props.complete ?
                        1
                        :
                        0.5,
                        filter: props.modal && "invert(100%)"
                    }} />
                    <P weight={"bold"} size={20} opacity={props.cart ? 0.5 : props.payment ? 0.5 : props.complete ?
                            1
                            :
                            0.5}> 상품수령 </P>
                </Inline>
            </Center>
        </div>
    );
}

export default ProcessBar;